import { timeLineSchema } from "@/schemas/timeline-schema";
import { IfetchTimelineResult } from "@/types/timeline-type";

export const fechTimeline = async (): Promise<IfetchTimelineResult> => {
	try {
		const res = await fetch(
			"https://kuwait.exelys.io/kuwait_warning/digital_warning_kuwait-202601131800.xml",
		);

		if (!res.ok) throw new Error("Une erreur est survenue");

		const xmlText = await res.text();

		const parse = new DOMParser();
		const xmlParsed = parse.parseFromString(xmlText, "text/xml");

		const infoSelector = xmlParsed.querySelectorAll("info");

		const infoSelectorValidated = Array.from(infoSelector)
			.map((item: Element) => {
				const get = (tag: string, parent: Element = item) =>
					parent.querySelector(tag)?.textContent?.trim();

				const areaElement = item.querySelector("area");

				const data = {
					language: get("language"),
					event: get("event"),
					urgency: get("urgency"),
					certainty: get("certainty"),
					severity: get("severity"),
					effective: get("effective"),
					expires: get("expires"),
					onset: get("onset"),
					area: areaElement
						? {
								areaDesc: get("areaDesc", areaElement),
						  }
						: undefined,
				};

				if (data.language === "ar-AR") return;

				const { error, data: parsed } = timeLineSchema.safeParse(data);

				if (error) return;

				return {
					event: parsed.event,
					severity: parsed.severity,
					effective: parsed.effective,
					expires: parsed.expires,
					areaDesc: parsed.area.areaDesc.toLowerCase().trim(),
				};
			})
			.filter((item) => item != undefined);

		return {
			isLoading: false,
			error: null,
			timelineData: infoSelectorValidated,
		};
	} catch {
		return {
			isLoading: false,
			error: "Une erreur est survenue",
			timelineData: [],
		};
	}
};
